import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ButtonCustom from '../../../../../Components/ButtonCustom'
import { Inline } from '../../../../../Components/CustomUi/inline'
import Input from '../../../../../Components/CustomUi/input'
import { ItensPerUserLogged } from '../../../../../services/login/permissaoUsuarioLoado'
import { faEdit, faEye, faPlus } from '@fortawesome/free-solid-svg-icons'
import { HeaderTable } from '../../../../../Components/CustomUi/table/headerTable'
import { BodyTable } from '../../../../../Components/CustomUi/table/bodyTable'
import { Render } from '../../../../../Components/CustomUi/render'
import { RowTable } from '../../../../../Components/CustomUi/table/rowTable'
import { RowItem } from '../../../../../Components/CustomUi/table/rowItem'
import { DeleteButton } from '../../../../../Components/CustomUi/deleteButton'
import { removerAcentos } from '../../../../../utils'
import { Empty } from 'antd'
import Carregando from '../../../../../Components/CustomUi/loading'
import { mascaraOdom, removeMaskValor, removerDecimal } from '../../../../../services/Afins'

interface PropsTabela {
  loading: boolean
  setPagination: React.Dispatch<React.SetStateAction<number>>
  page: number
  setPage: React.Dispatch<React.SetStateAction<number>>
  total: number
  listar_abastecimento: any[]
  abrir: Function
  permissao: ItensPerUserLogged
  editar: Function
  deletar: Function
  buscar_tabela: string
  setBuscar_tabela: React.Dispatch<React.SetStateAction<string>>
  confirmar_exclusao: boolean
  setConfirmar_exclusao: React.Dispatch<React.SetStateAction<boolean>>
  id_item_atual: number
  setId_item_atual: React.Dispatch<React.SetStateAction<number>>
  nome_item_atual: string
  setNome_item_atual: React.Dispatch<React.SetStateAction<string>>
  fake_loading: boolean
}

export const TabelaAbastecimento: React.FC<PropsTabela> = ({
  loading,
  setPagination,
  page,
  setPage,
  total,
  listar_abastecimento,
  abrir,
  permissao,
  editar,
  deletar,
  buscar_tabela,
  setBuscar_tabela,
  confirmar_exclusao,
  setConfirmar_exclusao,
  id_item_atual,
  setId_item_atual,
  nome_item_atual,
  setNome_item_atual,
  fake_loading,
}) => {
  function buscarAbastecimento(buscar_nome: string) {
    const palavraSemAcentos = removerAcentos(buscar_nome)
    return function (item) {
      const nomeSemAcentos = removerAcentos(String(item?.nome))
      return nomeSemAcentos.toLowerCase().includes(palavraSemAcentos.toLowerCase()) || !buscar_nome
    }
  }

  return (
    <div>
      <Inline alignItems='center'>
        <Input
          placeholder='Buscar centro de custos'
          value={buscar_tabela}
          onChange={setBuscar_tabela}
        />
        <ButtonCustom icon={<FontAwesomeIcon icon={faPlus} />} onClick={abrir}>
          Novo
        </ButtonCustom>
      </Inline>
      <HeaderTable
        itens={[
          { valor: 'Nome', width: 'calc(100% - 815.5px)' },
          { valor: 'Veículo', width: '400px' },
          { valor: 'Odômetro', width: '130px' },
          { valor: 'Frota', width: '120px' },
          { valor: 'Ações', width: '160px' },
        ]}
      />

      <BodyTable
        paginate={total}
        onChangeItensPage={setPagination}
        onChangePage={setPage}
        current_page={page}
        setCurrent_page={setPage}
        style={{
          height: (listar_abastecimento ?? []).length < 8 && 'calc(100vh - 170px)',
          position: 'relative',
          overflowX: 'hidden',
          overflowY: 'scroll',
          marginTop: -10,
        }}
      >
        <Render condition={!loading}>
          {(listar_abastecimento ?? [])
            .filter(buscarAbastecimento(buscar_tabela))
            .map(({ cod, nome_posto, usuario_nome, veiculo_nome, odom_atual, frota }, index) => {
              return (
                <RowTable
                  style={{ marginTop: index === 0 ? '10px' : '0px' }}
                  key={cod}
                  onDoubleClick={() => editar(cod)}
                >
                  <RowItem fontSize={13} width={'calc(100% - 810px)'}>
                    {usuario_nome}
                  </RowItem>

                  <RowItem fontSize={13} width={'400px'}>
                    {veiculo_nome}
                  </RowItem>

                  <RowItem fontSize={13} width={'130px'}>
                    {mascaraOdom(removerDecimal(odom_atual))}
                  </RowItem>

                  <RowItem fontSize={13} width={'120px'}>
                    {frota}
                  </RowItem>

                  <RowItem width={'160px'} gap={10}>
                    <DeleteButton
                      open={confirmar_exclusao && id_item_atual === cod}
                      trigger={setConfirmar_exclusao}
                      onTrigger={() => {
                        setId_item_atual(cod)
                        setNome_item_atual(usuario_nome)
                      }}
                      loading={fake_loading}
                      message={`o item ${usuario_nome} será excluido!`}
                      deleteds={[usuario_nome]}
                      onDelete={() => {
                        deletar(cod)
                      }}
                      disabled={fake_loading || permissao?.exclusao === 0}
                      disabledTrigger={permissao?.exclusao === 0}
                    />
                    <ButtonCustom
                      icon={<FontAwesomeIcon icon={(permissao?.alteracao === 0 || permissao?.inclusao === 0) ? faEye : faEdit} />}
                      onClick={() => editar(cod)}
                      disabled={permissao?.alteracao === 0 && permissao?.acesso === 0}
                    >
                      {(permissao?.alteracao === 0 || permissao?.inclusao === 0) ? 'Ver' : 'Editar'}
                    </ButtonCustom>
                  </RowItem>
                </RowTable>
              )
            })}
        </Render>

        <Render condition={listar_abastecimento?.length === 0 && !loading}>
          {buscar_tabela === '' ? (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={<> Nenhum registro disponível!</>}
            />
          ) : (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={
                <>
                  {' '}
                  <b>'{buscar_tabela}'</b> não encontrado!
                </>
              }
            />
          )}
        </Render>

        <Render condition={loading}>
          <Carregando
            animation
            legenda='Carregando abastecimentos...'
            justifyContent='center'
            height={200}
            size='default'
          />
        </Render>
      </BodyTable>
    </div>
  )
}
